import { getAuthAxiosBackend } from "@/helpers/axios"

class EducationDataServices{

    get(id){
        return getAuthAxiosBackend().get('EducationData/getEducationData/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('EducationData/getEducationDataByPersonId/' + personId.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('EducationData/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('EducationData/addEducationData', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('EducationData/updateEducationData/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('EducationData/softDeleteEducationData/' + id.toString())
    }
}

export default new EducationDataServices()